// extracted by mini-css-extract-plugin
export default {"wallet":"WalletPaymentButton_wallet__+NKez","payWithCardText":"WalletPaymentButton_payWithCardText__egkob","hidden":"WalletPaymentButton_hidden__njRWC"};